import { render, staticRenderFns } from "./ChoseNameModal.vue?vue&type=template&id=98df00ae&scoped=true"
import script from "./ChoseNameModal.vue?vue&type=script&lang=js"
export * from "./ChoseNameModal.vue?vue&type=script&lang=js"
import style0 from "./ChoseNameModal.vue?vue&type=style&index=0&id=98df00ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98df00ae",
  null
  
)

export default component.exports